import { useQuery } from "@tanstack/react-query";
import { fetchEquitiesData } from "@/lib/markets.functions";

export interface EquityQuote {
  symbol: string;
  name: string;
  price: number;
  change_1d: number;
  change_7d: number;
  series: Array<[number, number]>;
}

export interface EquitiesPayload {
  indices: EquityQuote[];
  tech_stocks: EquityQuote[];
  fetched_at?: string;
}

export function useEquities() {
  return useQuery<EquitiesPayload>({
    queryKey: ["equities"],
    queryFn: async () => {
      const data = await fetchEquitiesData();
      return {
        indices: data?.indices ?? [],
        tech_stocks: data?.tech_stocks ?? [],
        fetched_at: data?.fetched_at,
      };
    },
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
    retry: 1,
  });
}
